/**
 * Scrolls view back to top on navigation.
 * 
 * Shamelessly copied from https://www.kindacode.com/article/react-router-dom-scroll-to-top-on-route-change/
 * Copypaste date: 2022-02-13
 */
 import { useEffect } from "react";
 import { useLocation } from "react-router";
 
 const NavigationScrollToTop = (props) => {
   const location = useLocation();
   useEffect(() => {
     window.scrollTo(0, 0);
   }, [location]);
 
   return <>{props.children}</>
 };
 
 export default NavigationScrollToTop;
 